// import { elements as showLessMoreChannels } from '../helpers/dom/elementsManagement';
// import { filterCategories } from '../filterCategories';

/**
 * List of html elements
 *
 * @param {HTMLElement} $elementParent
 * @returns {HTMLAllCollection} as {Array}
 */
function _arrayOfNodeElems ($elementParent) {
    // console.log('$elementParent', $elementParent)
    if ($elementParent)
    return Array.from($elementParent.querySelectorAll('.placeholder'));
}

/**
 * List of html elements (tv packets) are shown
 *
 * @param {NodeSelector} idWhereFindElems
 * @param {HTMLElement} $root
 * @returns {HTMLAllCollection} as {Array}
 */
function _allShownElements (idWhereFindElems, $root) {
    // console.log('idWhereFindElems', idWhereFindElems, '$root', $root);
    const $elementParent = $root.querySelector(idWhereFindElems);
    let $elementsFromActiveFilter = _arrayOfNodeElems($elementParent);
    if ($elementsFromActiveFilter) {
        $elementsFromActiveFilter = $elementsFromActiveFilter.filter(el => !el.classList.contains('is-hidden'));
    }
    return $elementsFromActiveFilter;
}

/**
 * Set background color and text aligment for placeholder of item
 *
 * @param {NodeSelector} idElementParent
 * @param {HTMLElement} $root
 */
function _setVariantsForElements (idElementParent, $root, setAppearanceZebra) {
    // console.log('setAppearanceZebra', setAppearanceZebra);
    if (setAppearanceZebra) {
        const $elementParent = $root.querySelector(idElementParent);
        const $elementsWithBgColor = _arrayOfNodeElems($elementParent);
        if ($elementsWithBgColor) {
            const $elementsIsShown = $elementsWithBgColor.filter(el => !el.classList.contains('is-hidden'));

            $elementsWithBgColor.forEach($item => {
                if ($item.classList.contains('placeholder--b2c-gray')) {
                    $item.classList.remove('placeholder--b2c-gray');
                }
                $item.querySelector('div.tv-packages').classList.remove('tv-packages--right');
            });
    
            $elementsIsShown.forEach(($item, indexItem) => {
                const $tvPackageItem = $item.querySelector('div.tv-packages');
                if (indexItem % 2 === 0) {
                    $item.classList.add('placeholder--b2c-gray');
                    // $tvPackageItem.classList.add('left');
                } else {
                    $tvPackageItem.classList.add('tv-packages--right');
                }
            });
        }

    }
}

/**
 * @description Action of show more tv packets
 *
 * @param {NodeSelector} idWhereFindElems
 * @param {HTMLElement} $root
 */
function _showMoreElements (idWhereFindElems, $root) {
    const $btnToShowMore = $root.querySelector(`button[data-action="${idWhereFindElems}"]`);
    const $elementsFromActiveFilter = _allShownElements(idWhereFindElems, $root);

    // TOFIX: multiple fire this event; problaby problem is releated from "swiper" from filter tabs
    if ($btnToShowMore) {
        $btnToShowMore.addEventListener('click', function (event) {
            PacketsTv.shownAllElements = true;

            this.classList.add('is-hidden');
            _setVariantsForElements(idWhereFindElems, $root);
            $elementsFromActiveFilter.forEach($item => $item.classList.remove('is-hidden-start'));
            // console.log('PacketsTv.shownAllElements => _showMoreElements CLICK', PacketsTv.shownAllElements)
        });
    }

    // console.log('PacketsTv.shownAllElements => _showMoreElements', PacketsTv.shownAllElements)
}

/**
 * @description Show or hide button and html elements of packets tv
 *
 * @param {NodeSelector} idWhereFindElems
 * @param {HTMLElement} $root
 * @param {Boolean} elementsToShow
 */
function _hideMoreElements (idWhereFindElems, $root, elementsToShow, isShownAll) {
    isShownAll = PacketsTv.shownAllElements ? PacketsTv.shownAllElements : isShownAll;
    const $btnToShowMore = $root.querySelector(`button[data-action="${idWhereFindElems}"]`);
    let $elementsFromActiveFilter = _allShownElements(idWhereFindElems, $root);
    // console.log('PacketsTv.shownAllElements => _hideMoreElements', isShownAll)
    // reset hidden state of all elements to show more
    $elementsFromActiveFilter.forEach($item => $item.classList.remove('is-hidden-start'));

    // hide elements to "show more"
    if ($elementsFromActiveFilter.length > elementsToShow) {
        // one-time use of the show more button; has an impact for all filters
        if (!isShownAll) {
            let hiddenElementsLength = 0;

            // Hide element to show more
            $elementsFromActiveFilter.forEach(($item, index) => {
                if ((index + 1) > elementsToShow) {
                    $item.classList.add('is-hidden-start');
                    hiddenElementsLength++;
                }
            });
            // console.log(hiddenElementsLength, $elementsFromActiveFilter)

            // Show or hide button "show more"
            if ($btnToShowMore) {
                if (hiddenElementsLength > 0) {
                    $btnToShowMore.classList.remove('is-hidden');
                } else {
                    $btnToShowMore.classList.add('is-hidden');
                }
            }
        }
    } else {
        // lack of packets are hidden
        if ($btnToShowMore) {
            $btnToShowMore.classList.add('is-hidden');
        }
    }
}

/**
 * @description Init all methods for "showMore" funcionality
 *
 * @param {NodeSelector} idWhereFindElems
 * @param {HTMLElement} $root
 * @param {Number} elementsToShow
 * @param {Boolean} isShownAll
 */
function _initShowMoreElements (idWhereFindElems, $root, elementsToShow, isShownAll) {
    _hideMoreElements(idWhereFindElems, $root, elementsToShow, isShownAll);
    _showMoreElements(idWhereFindElems, $root);
}

/**
 * @classdesc Display list of packets TV
 * @summary This class is releated with other modules:
 * TabsFilters,
 * searchChannels,
 * elementsManagement
 *
 * @class PacketsTv
 */
class PacketsTv {
    /**
     * @param {Object} props
     * @param {HTMLElement} props.root ex. 'document.querySelector('#app')
     * @param {NodeSelector} [props.idElementParent='#searchChannelsContent'] ex. '#searchChannelsContent'
     * @param {Boolean} props.setAppearanceZebra ex. true or false; it colors items on list like "zebra style"
     * @
     * @memberof PacketsTv
     */
    constructor (props) {
        // console.log('PacketsTv => props', props);
        this.$root = props.root;
        this.idElementParent = props.idElementParent || '#searchChannelsContent';
        this.showElemsOnStart = 10;
        this.showButtonMore = (typeof props.showButtonMore === 'undefined' || props.showButtonMore === null) ? true : props.showButtonMore
        this._shownAll = false;
        this.setAppearanceZebra = (typeof props.setAppearanceZebra === 'undefined' || props.setAppearanceZebra === null) ? true : props.setAppearanceZebra;        
    }

    /**
     *
     *
     * @memberof TabsFilters
     */
    init () {
        // console.log('init packets');
        if (this.$root.querySelector(this.idElementParent)) {
            // console.log('PacketsTv => INIT', this)
            this.setVariantsForElements();
            this.initShowMoreElements();
        }
    }

    /**
     *
     *
     * @param {NodeSelector} [idWhereFindElems=this.idElementParent]
     * @param {HTMLElement} [$root=this.$root]
     * @param {Boolean} [setAppearanceZebra=this.setAppearanceZebra]
     * @memberof PacketsTv
     */
    setVariantsForElements (idWhereFindElems = this.idElementParent, $root = this.$root, setAppearanceZebra = this.setAppearanceZebra) {
        _setVariantsForElements(idWhereFindElems, $root, setAppearanceZebra);
    }

    /**
     *
     *
     * @param {NodeSelector} [idWhereFindElems=this.idElementParent]
     * @param {HTMLElement} [$root=this.$root]
     * @param {Number} [elementsToShow=this.showElemsOnStart]
     * @param {Boolean} [isShownAll=this._shownAll]
     * @memberof PacketsTv
     */
    initShowMoreElements (idWhereFindElems = this.idElementParent, $root = this.$root, elementsToShow = this.showElemsOnStart, isShownAll = this._shownAll) {
        _initShowMoreElements(idWhereFindElems, $root, elementsToShow, isShownAll);
    }

    /**
     *
     *
     * @memberof PacketsTv
     */
    tirggerShowMore () {
        // console.log('this', this);
        if (this.showButtonMore) {
            this._shownAll = true;
            this.setVariantsForElements();
            
            const $btnToShowMore = this.$root.querySelector(`button[data-action="${this.idElementParent}"]`);
            // console.log('this.idElementParent', this.idElementParent, 'this.$root', this.$root);
            const $elementsFromActiveFilter = _allShownElements(this.idElementParent, this.$root);

            if ($btnToShowMore)
            $btnToShowMore.classList.add('is-hidden');
            if ($elementsFromActiveFilter)
            $elementsFromActiveFilter.forEach($item => $item.classList.remove('is-hidden-start'));

            // console.log('PacketsTv.shownAllElements => tirggerShowMore', this._shownAll);
        }
    }

    /**
     *
     *
     * @memberof PacketsTv
     */
    set shownAllElements (new_shownAll) {
        if (new_shownAll) {
            this._shownAll = new_shownAll;
        }
    }

    /**
     *
     *
     * @memberof PacketsTv
     */
    get shownAllElements () {
        return this._shownAll;
    }
}

export default PacketsTv;
